
import React from 'react'
import Lightbox from "../../components/features/gallery/Lightbox";
import { useSelector } from "react-redux";
import GallerySubsectionModal from 'layout/modals/GallerySubsectionModal';
import ImagesIcon from "../../assets/site_material/icons/gallery-icon-photo-camera.png"
import VideosIcon from "../../assets/site_material/icons/gallery-icon-video-camera.png"
import ProgramsIcon from "../../assets/site_material/icons/gallery-icon-programs.png"
import HeaderModal from 'layout/modals/HeaderModal';

const Gallery = () => {

  const { gallery, images, chronology_images } = useSelector((state) => state.content);
  return ( 
    <>
      <HeaderModal headerText={gallery['header']} headerTag={"h1"}/>
      <div id='gallery-content-modal'>
        <GallerySubsectionModal header={gallery.subsection_headers.images} image={ImagesIcon}>
          <Lightbox
            images={images}
          />
        </GallerySubsectionModal>
        <GallerySubsectionModal header={gallery.subsection_headers.programs} image={ProgramsIcon}>
          <Lightbox
            images={chronology_images}
          />
        </GallerySubsectionModal>
        <GallerySubsectionModal header={gallery.subsection_headers.videos} image={VideosIcon}>
          <div className='gallery-video-content'>
            <iframe src="https://www.youtube.com/embed/x6Bs9wKp-M4" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
            <iframe src="https://www.youtube.com/embed/lCl_jPQSh0I" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
            
          </div>
        </GallerySubsectionModal>

      </div>

    </>
  );
};

export default Gallery;
